import React, { Dispatch, FC, SetStateAction, useEffect, useMemo, useRef, useState } from "react";
import { observer } from "mobx-react-lite";
import styles from "../../index.module.scss";
import { galleryLangRecords } from "@/pages/Gallery/lang";
import { langStore } from "@noli/business";
import { useAsyncEffect, useClickAway } from "ahooks";
import { getReportType, postReportOpus } from "@/pages/Gallery/api";
import { Toast } from "@/components/Toast";
import { ImgAndPromptItemType } from "@/stores/gallery";

interface ReportTypesProps {
  create_time: string;
  id: number;
  name: string;
  sort: number;
}
interface ReportProps {
  reportVisible: boolean;
  current?: ImgAndPromptItemType;
  setReportVisible: Dispatch<SetStateAction<boolean>>;
}

const Report: FC<ReportProps> = (props) => {
  const { reportVisible, current, setReportVisible } = props;
  const lang = langStore.tgt;
  const reportRef = useRef<HTMLDivElement | null>(null);
  const [reportTypes, setReportTypes] = useState<ReportTypesProps[]>([]);
  const [reportData, setReportData] = useState<{
    report_type: number[];
    report_reasons: string;
  }>({
    report_type: [],
    report_reasons: "",
  });
  useClickAway(() => {
    if (reportRef) {
      reportRef.current?.blur();
    }
  }, reportRef);
  useEffect(() => {
    if (reportRef?.current) {
      reportRef.current.innerText = galleryLangRecords[lang]["Enter-The-Reason-For-Reporting"];
    }
  }, [reportVisible]);
  useAsyncEffect(async () => {
    const {
      data: { report_types },
    } = await getReportType();
    setReportTypes(report_types);
  }, []);
  const reportTypeNode = useMemo(() => {
    return reportTypes.map((prod) => {
      return (
        <li
          key={prod.id}
          className={`${reportData.report_type.includes(prod.id) ? styles.active : ""}`}
          onClick={() => {
            setReportData({
              ...reportData,
              report_type: reportData.report_type.includes(prod.id)
                ? reportData.report_type.filter((item) => item !== prod.id)
                : [...reportData.report_type, prod.id],
            });
          }}
        >
          {prod.name}
        </li>
      );
    });
  }, [reportTypes, reportData]);
  // 确认举报
  const handleReport = async () => {
    try {
      await postReportOpus({
        report_reasons: reportRef.current?.innerText,
        image_id: current?.image_id as number,
        report_type: reportData.report_type.join(","),
      });
      setReportVisible(false);
      Toast({
        status: "success",
        position: "top",
        description: galleryLangRecords[lang]["Report-submitted-successfully"],
      });
    } catch (e) {
      console.error(e);
    }
  };
  return (
    <div className={styles.reportWrapper}>
      <p className={styles.title}>{galleryLangRecords[lang]["SureReport"]}</p>
      <p className={styles.littleTitle}>{galleryLangRecords[lang]["SelectReason"]}</p>
      <ul className={styles.reportTypeWrapper}>{reportTypeNode}</ul>
      <p className={styles.littleTitle}>{galleryLangRecords[lang]["OtherReportingReasons"]}</p>
      <div
        ref={reportRef}
        contentEditable
        className={`${styles.reportReasons} ${reportData.report_reasons ? "" : styles.placeholder}`}
        onFocus={(e) => {
          if (!reportData.report_reasons) {
            e.target.innerText = "";
          }
        }}
        onBlur={(e) => {
          if (!reportData.report_reasons) {
            e.target.innerText = galleryLangRecords[lang]["EnterReason"];
          }
        }}
        onInput={(e: any) => {
          setReportData({
            ...reportData,
            report_reasons: e.target.innerText,
          });
        }}
      />
      <div className={styles.btnWrapper}>
        <button
          onClick={(e) => {
            e.stopPropagation();
            setReportVisible(false);
          }}
        >
          {galleryLangRecords[lang]["Cancel"]}
        </button>
        <button
          disabled={!reportData.report_type.length}
          onClick={async (e) => {
            e.stopPropagation();
            await handleReport();
          }}
        >
          {galleryLangRecords[lang]["ConfirmTheReport"]}
        </button>
      </div>
    </div>
  );
};
export default observer(Report);
